import { authClient, baseClient, getServiceURL } from '@/utils'
import { action } from '@/utils/actions.utils'
import Toggles from '@domain/toggles/Toggles'
import { ApiCaller } from '@front/utils'
import { getServiceURLserverSide } from '@infrastructure/Urls'
import { MANAGE_USER_ACTION_ACCEPT, MANAGE_USER_ACTION_REJECT } from '@/constants/constants'

const getUser = (userId) => {
	return authClient.get(`${getServiceURL('users')}/v1/users/${userId}`)
}

// only send user data accesible by other users, for private data use getUser instead
const getUserInfo = (userId) => {
	return authClient.get(`${getServiceURLserverSide('v3')}/user/info/${userId}`)
}

const getUserByEmail = (email) => {
	return baseClient
		.get(`${getServiceURL('users')}/v1/users/email-validate/${email}`)
		.then((data) => data)
		.catch((error) => error)
}

const userConfigurationsBySiteLocation = (siteLocation) => {
	return authClient.get(`${getServiceURL('masters')}/v1/configurations`, {
		params: {
			siteLocation
		}
	})
}

const fetchBusinessActivitiesType = ({ lang }) => {
	return baseClient.get(`${getServiceURL('users')}/v1/company-types`, {
		params: { lang }
	})
}

const fetchSubmenuLinks = ({ catalogId, role }) => {
	return authClient.get(`${getServiceURL('masters')}/v1/configurations/menus`, {
		params: { catalogId, role }
	})
}

const checkEmailAvailability = (email) => {
	return baseClient
		.get(`${getServiceURL('users')}/v1/users/email-validate/${email}`)
		.then(() => ({
			data: false,
			status: 200
		}))
		.catch((error) => {
			if (error.response.status === 404) {
				return {
					data: true,
					status: 200
				}
			}
			return error
		})
}

const updateClientCode = ({ userId, clientCode, lang }) => {
	return authClient.patch(`${getServiceURL('users')}/v1/users/${userId}/client-code`, {
		clientCode: clientCode,
		lang
	})
}

const updateLanguage = async (userId, selectedLanguage) => {
	const languageId = selectedLanguage.id
	const languageIsoCode = selectedLanguage.isoCode
	let data
	data = await ApiCaller.call('v2', "PUT", `user/${userId}`, JSON.stringify({ language: selectedLanguage }))
	return data
}

const fetchUsersPrivileges = (crmCopmanyID) => {
	if (Toggles.isEnabled("onQualifyUserCanAddToCompanyById"))
		return authClient.get(`${getServiceURLserverSide('v3')}/company/${crmCopmanyID}/users`)
	else
		return authClient.get(`${getServiceURL('users')}/v1/users/manage/by-company/${crmCopmanyID}`)
}

const updateUsersPrivileges = ({ updatedPrivileges }) => {
	return authClient.patch(`${getServiceURL('users')}/v1/users/manage/by-company/modify-user-privileges`,
		updatedPrivileges
	)
}
const updateUserAboutYou = async (userId, formData) => {
	let response
	const data = await ApiCaller.call('v2', "PUT", `user/${userId}`, JSON.stringify(formData), { credentials: "include" })
	response = { data }
	return response
}

const manageUserInCompany = async (userId, action_type, companyId) => {
	if (action_type !== MANAGE_USER_ACTION_ACCEPT && action_type !== MANAGE_USER_ACTION_REJECT) {
		throw new Error('Invalid action type. Use "accept" or "reject".')
	}
	const r = await authClient.post(`${getServiceURLserverSide('v3')}/company/${companyId}/users/${userId}/${action_type}`)
	return r
}

const updateUserAboutCompany = async (userId, formData) => {
	let response = null

	const companyId = formData.company?.crmId
	// Send userId so the backend can resolve the editor's CRM contact id and bust the
	// company caches that feed GET /account — otherwise the saved data doesn't show until
	// the Redis TTL expires or the cache is flushed by hand.
	const data = await ApiCaller.call('v2', "PUT", `company/${companyId}`, JSON.stringify({ ...formData, userId }), { credentials: "include" })
	response = { data }
	return response
}


const getUserProfessions = () => baseClient.get(`${getServiceURL('apiv2')}/options/professions`)

const updateRoleCRM = async (email, role) => {
	return authClient.post(`${getServiceURLserverSide('v3')}/user/role`, { email, role })
}

const sendUserInvitationToCompany = async (email, role, companyId) => {
	return authClient.post(`${getServiceURLserverSide('v3')}/user/${companyId}/invite`, { email, role })
}

const getUserInvitationByCompany = async (companyId) => {
	return authClient.get(`${getServiceURLserverSide('v3')}/company/${companyId}/invitations`)
}

const checkInvitationByUser = async (userId) => {
	return authClient.get(`${getServiceURLserverSide('v3')}/user/checkInvitation`, { userId })
}

export default {
	getUser,
	getUserByEmail,
	getUserProfessions,
	fetchBusinessActivitiesType,
	fetchSubmenuLinks,
	checkEmailAvailability,
	fetchUsersPrivileges,
	updateClientCode,
	userConfigurationsBySiteLocation,
	updateLanguage,
	updateUsersPrivileges,
	updateUserAboutYou,
	updateUserAboutCompany,
	manageUserInCompany,
	updateRoleCRM,
	sendUserInvitationToCompany,
	getUserInvitationByCompany,
	checkInvitationByUser,
	getUserInfo
}
